import { render } from "./CopyBatteriesModal.vue?vue&type=template&id=67271a38"
import script from "./CopyBatteriesModal.vue?vue&type=script&lang=js"
export * from "./CopyBatteriesModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__